<template>
  <div id="app" class="">

    <div class="app-main footer-style-one" >
      <div id="app" class="exam_page" >
        <div class="exam_header" >
          <div class="header_flex" >
            <div class="exit_exam" @click="existTest">退出考试</div>
            <div class="exam_title" >{{majorName}}</div>
            <div class="exam_time_box" ><!---->
              <button @click="postAnswer" class="el-button el-button--primary el-button--small pointer" aria-disabled="false" type="button"><!--v-if-->
                <span class="" style="color: #ffffff" >交卷</span>
              </button>
            </div>
          </div>
        </div>
        <div class="exam_paper_box" >
<!--          <div class="exam_user_paper" >
            <div class="exam_user_item" >
              <div class="exam_user_top" >
                <span class="el-avatar el-avatar&#45;&#45;circle"  style="&#45;&#45;el-avatar-size:40px;">
                  <img src="https://static.roncoo.com/1509056670027567105/70d52071cb9a4d47b6212f144c984f3c.jpg" style="object-fit: cover;">
                </span>
              </div>
              <div class="exam_user_bottom" >手机尾号7170的用户</div>
            </div>
            <div class="exam_user_item" >
              <template>
                <el-switch
                        active-value="1"
                        inactive-value="0"
                        >
                </el-switch>
                自动下一题
              </template>
            </div>
            <div class="exam_user_item" >
              <template>
                <el-switch
                        active-value="1"
                        inactive-value="0"
                >
                </el-switch>
                自动显示答案解析
              </template>
            </div>
            <div class="exam_user_item" >
              <template>
                <el-switch
                        active-value="1"
                        inactive-value="0"
                >
                </el-switch>
                背题模式
              </template>
            </div>
          </div>-->
          <div class="exam_center" >
            <el-form ref="form" :model="form" label-width="80px" >
              <div class="left" >

              <div class="question_box" v-for="(i,k) in questionList" :key="k">
                <div>
                  <!--单选题-->
                  <div v-if="i.question_type_id==1">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.question }}(单选题)</div>
                    </div>
                    <template>
                      <el-radio-group class="radios_group" v-model="form[i.id]">
                        <el-radio label="A" class="option-input" v-if="i.options1" value="A">A、{{i.options1}}</el-radio>
                        <el-radio label="B" class="option-input" v-if="i.options2" value="B">B、{{i.options2}}</el-radio>
                        <el-radio label="C" class="option-input" v-if="i.options3" value="C">C、{{i.options3}}</el-radio>
                        <el-radio label="D" class="option-input" v-if="i.options4" value="D">D、{{i.options4}}</el-radio>
                        <el-radio label="E" class="option-input" v-if="i.options5" value="E">E、{{i.options5}}</el-radio>
                        <el-radio label="F" class="option-input" v-if="i.options6" value="F">F、{{i.options6}}</el-radio>
                      </el-radio-group>
                    </template>
                  </div>

                  <!--多选题-->
                  <div v-if="i.question_type_id==2">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.question }}(多选题)</div>
                    </div>
                    <template>

                      <el-checkbox-group v-model="checkRes[`${i.id}`]">
                        <el-checkbox label="A"   value="A"  v-if="i.options1">A、{{i.options1}}</el-checkbox>
                        <el-checkbox label="B"   value="B"  v-if="i.options2">B、{{i.options2}}</el-checkbox>
                        <el-checkbox label="C"   value="C"  v-if="i.options3">C、{{i.options3}}</el-checkbox>
                        <el-checkbox label="D"   value="D"  v-if="i.options4">D、{{i.options4}}</el-checkbox>
                        <el-checkbox label="E"   value="E"  v-if="i.options5">E、{{i.options5}}</el-checkbox>
                        <el-checkbox label="F"   value="F"  v-if="i.options6">F、{{i.options6}}</el-checkbox>
                      </el-checkbox-group>

                    </template>
                  </div>

                  <!--判断题-->
                  <div v-if="i.question_type_id==3">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.question }}(判断题)</div>
                    </div>
                    <template>
                      <el-radio-group class="radios_group" v-model="form[i.id]">
                        <el-radio label="A" class="option-input" v-if="i.options1" value="A" >A、{{i.options1}}</el-radio>
                        <el-radio label="B" class="option-input" v-if="i.options2" value="B">B、{{i.options2}}</el-radio>
                      </el-radio-group>
                    </template>
                  </div>

                  <!--案例题-->
                  <div v-if="i.question_type_id==4">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.problem }}(案例题)</div>
                    </div>

                    <!--单选题-->
                    <div v-for="(value,inx) in i.childQues" :key="inx" style="margin-left: 50px">
                      <div v-if="value.question_type_id==1">
                        <div class="problemTitle font16 mgb20" >
                          <span>{{k+1}}.{{inx+1}}、</span>
                          <div >{{value.question }}(单选题)</div>
                        </div>
                        <template>
                          <el-radio-group class="radios_group" v-model="form[value.id]">
                            <el-radio label="A" class="option-input" v-if="value.options1" value="A">A、{{value.options1}}</el-radio>
                            <el-radio label="B" class="option-input" v-if="value.options2" value="B">B、{{value.options2}}</el-radio>
                            <el-radio label="C" class="option-input" v-if="value.options3" value="C">C、{{value.options3}}</el-radio>
                            <el-radio label="D" class="option-input" v-if="value.options4" value="D">D、{{value.options4}}</el-radio>
                            <el-radio label="E" class="option-input" v-if="value.options5" value="E">E、{{value.options5}}</el-radio>
                            <el-radio label="F" class="option-input" v-if="value.options6" value="F">F、{{value.options6}}</el-radio>
                          </el-radio-group>
                        </template>
                      </div>
                    </div>

                  </div>

                  <!--不定项-->
                 <div v-if="i.question_type_id==6">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.question }}(不定项题)</div>
                    </div>
                   <template>
                     <el-checkbox-group v-model="checkRes[`${i.id}`]">
                       <el-checkbox label="A"   value="A"  v-if="i.options1">A、{{i.options1}}</el-checkbox>
                       <el-checkbox label="B"   value="B"  v-if="i.options2">B、{{i.options2}}</el-checkbox>
                       <el-checkbox label="C"   value="C"  v-if="i.options3">C、{{i.options3}}</el-checkbox>
                       <el-checkbox label="D"   value="D"  v-if="i.options4">D、{{i.options4}}</el-checkbox>
                       <el-checkbox label="E"   value="E"  v-if="i.options5">E、{{i.options5}}</el-checkbox>
                       <el-checkbox label="F"   value="F"  v-if="i.options6">F、{{i.options6}}</el-checkbox>
                     </el-checkbox-group>
                   </template>
                  </div>

                  <!--简单题-->
                  <div v-if="i.question_type_id==7">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.question }}(简单题)</div>
                    </div>
                    <div>
                      <div class="el-textarea el-input&#45;&#45;small mgb10">
                      <textarea class="el-textarea__inner" color="#2256F6" v-model="form[i.id]"
                                rows="7"
                                tabindex="0" autocomplete="off"
                                placeholder="请输入答案"
                                id="el-id-100-174"
                                style="resize: none; min-height: 28px;">
                      </textarea>
                      </div>
                    </div>
                  </div>

                  <!--填空题-->
                  <div v-if="i.question_type_id==8">
                    <div class="problemTitle font16 mgb20" >
                      <span>{{k+1}}、</span>
                      <div >{{i.question }}(填空题)</div>
                    </div>
                    <div>
                      <div class="el-textarea el-input&#45;&#45;small mgb10">
                      <textarea class="el-textarea__inner" color="#2256F6" v-model="form[i.id]"
                                rows="7"
                                tabindex="0" autocomplete="off"
                                placeholder="请输入答案"
                                id="el-id-100-174"
                                style="resize: none; min-height: 28px;">
                      </textarea>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            </el-form>

          </div>
<!--          <div class="exam_right">
            <div class="exam_right_title" >答题卡</div>
            <div class="problem">
              <div class="problem_exam_box mgb20" >
                <div class="problem_exam_box_item true" >已答</div>
                <div class="problem_exam_box_item false">未答</div>
              </div>
              <div class="mgb20">
                <div class="card_box">
                  <span class="problem_num" v-for="(v,index) in questionList" :key="index">{{index+1}}</span>
                </div>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getTestQues,submitTest} from "@/api/moudles/user";

export default {
  name: "test",
  data(){

    return {
      major_id:'',
      scId:'',
      price_id:'',
      examRecordId:'',
      majorName:'',
      examTempId:'',
      beiTi :0,
      questionList:[],
      form:{},
      checkRes:{}
    }
  },

  components:{

  },

  created() {
    document.title = '模拟考试'
    this.major_id = this.$route.query.major_id
    this.majorName = this.$route.query.majorName
    this.scId = this.$route.query.scId
    this.price_id = this.$route.query.priceId
    this.examTempId = this.$route.query.examTempId

    this.fetchData()
  },

  methods:{

    postAnswer(){

      console.log('form',this.form)
      console.log('checkRes',this.checkRes)
      let token = localStorage.getItem('userToken')

      submitTest({
        data: {
          form:this.form,
          checkRes:this.checkRes,
          examRecordId:this.examRecordId,
          token:token
        },
        success: (res) => {
          console.log(res)
          if(res.code == 200){
            this.$message('交卷成功');
            setTimeout(function () {

              history.go(-1)
            },3000)
          }
        }
      })

    },
    changeMode(status){

      console.log(status)
      this.beiTi = status
    },
    fetchData(){
      let token = localStorage.getItem('userToken')

      getTestQues({
        data: {
          majorId:this.major_id,
          scId:this.scId,
          price_id:this.price_id,
          token:token,
          examTempId:this.examTempId
        },
        success: (res) => {
          console.log(res)
          this.questionList = res.data.questions
          this.examRecordId = res.data.examRecordId

          this.questionList.forEach(item => {

            if(item.question_type_id ==2){
              let key = item.id
              this.$set(this.checkRes, key, [])
            }

          })
        }
      })
    },

    existTest(){
      history.go(-1)
    },

  }

}
</script>

<style scoped>

.footer-style-one.app-main {
  min-height: calc(100vh - 150px);
}
.app-main{
  min-height: 100vh;
  padding-top: 66px;
  background-color: #f6f8fb;
}

#app {
  height: 100vh;
  overflow: auto;
}
html, body, #app {
  margin: 0;
  padding: 0;
}
.exam_page {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: #f6f8fb;
  z-index: 1001;
}
.exam_header {
  width: 100%;
  height: 54px;
  background: #fff;

}

.exam_header .header_flex {
  width: 1480px;
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exam_header .exit_exam {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.exam_header .exam_title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #333;
}

.exam_header .exam_time_box {
  min-width: 124px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.exam_header .el-button {
  width: 100px;
  height: 32px;
  border-radius: 4px;
  margin-left: 24px;
}
.pointer {
  cursor: pointer;
}
.pointer {
  cursor: pointer;
}
button, [type=button], [type=reset], [type=submit] {
  -webkit-appearance: button;
}
.el-button--small {
  --el-button-size: 24px;
  height: var(--el-button-size);
  padding: 5px 11px;
  font-size: 12px;
  border-radius: calc(var(--el-border-radius-base) - 1px);
}

.el-button>span {
  display: inline-flex;
  align-items: center;
}

.answer_radio .el-radio {
  display: block;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
.el-radio:last-child {
  margin-right: 0;
}
.el-radio.el-radio--small {
  height: 24px;
}
.el-radio {
  color: var(--el-radio-text-color);
  font-weight: var(--el-radio-font-weight);
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  outline: 0;
  font-size: var(--el-font-size-base);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 32px;
  height: 32px;
}
.el-radio {
  --el-radio-font-size: var(--el-font-size-base);
  --el-radio-text-color: var(--el-text-color-regular);
  --el-radio-font-weight: var(--el-font-weight-primary);
  --el-radio-input-height: 14px;
  --el-radio-input-width: 14px;
  --el-radio-input-border-radius: var(--el-border-radius-circle);
  --el-radio-input-bg-color: var(--el-fill-color-blank);
  --el-radio-input-border: var(--el-border);
  --el-radio-input-border-color: var(--el-border-color);
  --el-radio-input-border-color-hover: var(--el-color-primary);
}


.el-radio__input {
  white-space: nowrap;
  cursor: pointer;
  outline: 0;
  display: inline-flex;
  position: relative;
  vertical-align: middle;
}
.el-radio__original {
  opacity: 0;
  outline: 0;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}
input, button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  padding: 0;
  line-height: inherit;
  color: inherit;
}

.el-radio .el-radio__inner {
  height: 16px;
  width: 16px;
}
.el-radio.el-radio--small .el-radio__inner {
  width: 12px;
  height: 12px;
}
.el-radio__inner {
  border: var(--el-radio-input-border);
  border-radius: var(--el-radio-input-border-radius);
  width: var(--el-radio-input-width);
  height: var(--el-radio-input-height);
  background-color: var(--el-radio-input-bg-color);
  position: relative;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
}


.exam_paper_box {
  width: 100%;
  max-width: 1480px;
  padding-top: 16px;

  overflow: auto;
  margin: auto;
}
.exam_user_paper {
  background-color: #fff;
  width: 130px;
  position: fixed;
  left: calc(50% - 740px);
  top: 72px;
}

.exam_user_paper .exam_user_item {
  width: 100%;
  height: 33.3333333333%;
  border-bottom: 1px solid #EBEEF5;
  padding: 16px 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.exam_user_paper .exam_user_item .exam_user_top {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.el-avatar--circle {
  border-radius: 50%;
}

.el-avatar {
  --el-avatar-text-color: var(--el-color-white);
  --el-avatar-bg-color: var(--el-text-color-disabled);
  --el-avatar-text-size: 14px;
  --el-avatar-icon-size: 18px;
  --el-avatar-border-radius: var(--el-border-radius-base);
  --el-avatar-size-large: 56px;
  --el-avatar-size-small: 24px;
  --el-avatar-size: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  color: var(--el-avatar-text-color);
  background: var(--el-avatar-bg-color);
  width: var(--el-avatar-size);
  height: var(--el-avatar-size);
  font-size: var(--el-avatar-text-size);
}

.el-avatar>img {
  display: block;
  height: 100%;
}
img, video {
  max-width: 100%;
  height: auto;
}
img, canvas, iframe, video {
  display: block;
  vertical-align: middle;
}
/* img {
   border-style: solid;
 }
*/
.exam_user_paper .exam_user_bottom {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333;
  margin-top: 6px;
}
.exam_user_paper .exam_user_item {
  width: 100%;
  height: 33.3333333333%;
  border-bottom: 1px solid #EBEEF5;
  padding: 16px 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.exam_user_paper .exam_user_bottom {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333;
  margin-top: 6px;
}
.el-switch {
  display: inline-flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  height: 32px;
  vertical-align: middle;
}
.el-switch__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
}
input, button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  padding: 0;
  line-height: inherit;
  color: inherit;
}

.el-switch.is-checked .el-switch__core {
  border-color: var(--el-switch-border-color, var(--el-switch-on-color));
  background-color: var(--el-switch-on-color);
}

.el-switch__core {
  margin: 0;
  display: inline-block;
  position: relative;
  width: 40px;
  height: 20px;
  border: 1px solid var(--el-switch-border-color, var(--el-switch-off-color));
  outline: 0;
  border-radius: 10px;
  box-sizing: border-box;
  background: var(--el-switch-off-color);
  cursor: pointer;
  transition: border-color var(--el-transition-duration),background-color var(--el-transition-duration);
  vertical-align: middle;
}

.el-switch.is-checked .el-switch__core .el-switch__action {
  left: 100%;
  margin-left: -17px;
  color: var(--el-switch-on-color);
}
.el-switch__core .el-switch__action {
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: var(--el-border-radius-circle);
  transition: all var(--el-transition-duration);
  width: 16px;
  height: 16px;
  background-color: var(--el-color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--el-switch-off-color);
}
.exam_user_paper .exam_user_item .exam_user_top {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.exam_user_paper .exam_user_item {
  width: 100%;
  height: 33.3333333333%;
  border-bottom: 1px solid #EBEEF5;
  padding: 16px 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.exam_user_paper .exam_user_bottom {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333;
  margin-top: 6px;
}

.el-switch {
  display: inline-flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  height: 32px;
  vertical-align: middle;
}

.el-switch__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
}
input, button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  padding: 0;
  line-height: inherit;
  color: inherit;
}
.el-switch__core {
  margin: 0;
  display: inline-block;
  position: relative;
  width: 40px;
  height: 20px;
  border: 1px solid var(--el-switch-border-color, var(--el-switch-off-color));
  outline: 0;
  border-radius: 10px;
  box-sizing: border-box;
  background: var(--el-switch-off-color);
  cursor: pointer;
  transition: border-color var(--el-transition-duration),background-color var(--el-transition-duration);
  vertical-align: middle;
}
.el-switch__core .el-switch__action {
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: var(--el-border-radius-circle);
  transition: all var(--el-transition-duration);
  width: 16px;
  height: 16px;
  background-color: var(--el-color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--el-switch-off-color);
}
.exam_user_paper .exam_user_item .exam_user_top {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.exam_user_paper .exam_user_item {
  width: 100%;
  height: 33.3333333333%;
  border-bottom: 1px solid #EBEEF5;
  padding: 16px 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.exam_user_paper .exam_user_bottom {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333;
  margin-top: 6px;
}

.el-switch {
  display: inline-flex;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  height: 32px;
  vertical-align: middle;
}

.el-switch__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
}
input, button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  padding: 0;
  line-height: inherit;
  color: inherit;
}
.el-switch__core {
  margin: 0;
  display: inline-block;
  position: relative;
  width: 40px;
  height: 20px;
  border: 1px solid var(--el-switch-border-color, var(--el-switch-off-color));
  outline: 0;
  border-radius: 10px;
  box-sizing: border-box;
  background: var(--el-switch-off-color);
  cursor: pointer;
  transition: border-color var(--el-transition-duration),background-color var(--el-transition-duration);
  vertical-align: middle;
}

.el-switch__core .el-switch__action {
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: var(--el-border-radius-circle);
  transition: all var(--el-transition-duration);
  width: 16px;
  height: 16px;
  background-color: var(--el-color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--el-switch-off-color);
}

.exam_user_paper .exam_user_item .exam_user_top {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}


.exam_center {
  width: 1058px;
  margin-left: 146px;
}

.exam_center .left{
  position: relative;
  background: #ffffff;
}
.exam_center .left .question_box {
  position: relative;
  border-bottom: 1px solid #EBEEF5;
  padding: 20px 33px 20px 30px;
}
.problemTitle {
  width: 938px;
  display: flex;
}
.mgb20 {
  margin-bottom: 20px!important;
}
.font16 {
  font-size: 16px;
}

.problemTitle div:nth-child(2) {
  width: calc(100% - 18px);
}

.exam_right {
  width: 260px;
  background-color: #fff;
  position: fixed;
  top: 72px;
  right: calc(50% - 740px);
}

.exam_right .exam_right_title {
  margin-top: 21px;
  height: 54px;
  width: 100%;
  padding: 18px 27px;
  border-bottom: 1px solid #EBEEF5;
}

.exam_right .problem {
  padding: 20px 16px;
}

.exam_right .problem_exam_box {
  width: 100%;
  display: flex;
  align-items: center;
  -moz-column-gap: 12px;
  column-gap: 12px;
}
.mgb20 {
  margin-bottom: 20px!important;
}

.exam_center .left .collect_item {
  position: absolute;
  right: 0;
  top: 20px;
  min-width: 80px;
  height: 24px;
  display: flex;
  align-items: center;
  color: #999;
}

.exam_right .problem_exam_box_item {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #333;
  padding-left: 23px;
  position: relative;
  display: flex;
  align-items: center;
}


.exam_right .problem_exam_box_item {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #333;
  padding-left: 23px;
  position: relative;
  display: flex;
  align-items: center;
}

.mgb20 {
  margin-bottom: 20px!important;
}


.exam_right .title_type {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #333;
  margin-bottom: 14px;
}

.exam_right .problem .card_box .problem_num {
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 12px;
  width: 28px;
  height: 28px;
  color: #333;
  border: 1px solid #D9D9D9;
  text-align: center;
  line-height: 28px;
  border-radius: 2px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}

.exam_right .problem_exam_box_item.true:before {
  background: rgba(61,127,255,.1);
  border-radius: 1.6px;
  width: 16px;
  height: 16px;
  border: 1px solid rgba(61,127,255,.4);
}

.exam_right .problem_exam_box_item.wrong:before {
  background: rgba(242,60,60,.1);
  border-radius: 1.6px;
  width: 16px;
  height: 16px;
  border: 1px solid rgba(242,60,60,.4);
}

.exam_right .problem_exam_box_item:before {
  content: "";
  width: 16px;
  height: 16px;
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 1.6px;
  left: 0;
  position: absolute;
}
.exam_right .problem_exam_box_item:before {
  content: "";
  width: 16px;
  height: 16px;
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 1.6px;
  left: 0;
  position: absolute;
}


.radios_group{
  align-items: flex-start;
  flex-direction: column;
  row-gap: 20px;
}

.el-radio-group {
  align-items: center;
  flex-wrap: wrap;
  font-size: 0;
}

.el-checkbox{
  display: flex;
}

.el-radio {
  align-items: flex-start;
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
}

.el-radio:last-child {
  margin-right: 0;
}
.el-radio.el-radio--small {
  height: 24px;
}

.analysis {
  background: rgba(51,51,51,.05);
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 10px;
  margin-top: 20px;
  padding: 20px 26px;
  position: relative;
  width: 95%;
  z-index: 11;
}

.inline-b {
  display: inline-block;
}
.inline-b {
  display: inline-block;
}

.mgb20 {
  margin-bottom: 20px!important;
}
.mgr30 {
  margin-right: 30px!important;
}

.analysis .analysis_item {
  align-items: top;
  display: flex;
}

.analysis .analysis_item .left_text {
  width: 80px;
}

.blue_text {
  color: #3d7fff;
}

.inline-b {
  display: inline-block;
}
.inline-b {
  display: inline-block;
}

.mgb20 {
  margin-bottom: 20px!important;
}

.analysis .analysis_item {
  align-items: top;
  display: flex;
}
.red_text {
  color: #f23c3c;
}

.analysis .analysis_item {
  align-items: top;
  display: flex;
}

.analysis .analysis_item .left_text{
  width: 80px;
}

.option-input{
  margin-bottom: 20px;
}

</style>